import React, { useState, useEffect } from "react";
import axios from "axios";

const TransactionHistory = ({ userId }) => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const fetchAgentTransactions = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-agent-transactions?userId=${userId}`,
        getAuthHeaders()
      );
      setTransactions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchAgentTransactions(userId);
    } else {
      setTransactions([]);
    }
  }, [userId]);

  return (
    <div className="mt-6 bg-white p-4 rounded-xl shadow">
      <h3 className="text-xl font-semibold mb-2">Transaction History</h3>
      {transactions.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100 font-semibold">
              <tr>
                <th className="p-2">Service Id</th>
                <th className="p-2">Document Type</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Status</th>
                <th className="p-2">Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((transaction) => (
                  <tr
                    key={transaction._id}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="p-2">{transaction.idNumber || "-"}</td>
                    <td className="p-2">{transaction.documentType || "-"}</td>
                    <td className="p-2">
                      {transaction.amountDeducted || "N/A"}
                    </td>
                    <td className="p-2">
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          transaction.status === "success"
                            ? "bg-green-100 text-green-800"
                            : transaction.status === "pending" ||
                              transaction.status === "failed"
                            ? "bg-red-100 text-red-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                      >
                        {transaction.status === "success"
                          ? "success"
                          : "failed"}
                      </span>
                    </td>
                    <td className="p-2">
                      {new Date(transaction.createdAt).toLocaleString()}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {transactions.length > itemsPerPage && (
            <div className="flex justify-between items-center mt-4">
              <div>
                <span className="text-sm text-gray-700">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {Math.min(currentPage * itemsPerPage, transactions.length)} of{" "}
                  {transactions.length} entries
                </span>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Previous
                </button>
                <span className="px-3 py-1">
                  Page {currentPage} of{" "}
                  {Math.ceil(transactions.length / itemsPerPage)}
                </span>
                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(
                        prev + 1,
                        Math.ceil(transactions.length / itemsPerPage)
                      )
                    )
                  }
                  disabled={
                    currentPage ===
                    Math.ceil(transactions.length / itemsPerPage)
                  }
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="text-gray-500 text-sm">
          No transaction history available.
        </p>
      )}
    </div>
  );
};

export default TransactionHistory;
